import {Container, Row, Col, Button}from 'react-bootstrap';
import {useState} from 'react';
import Product from '../component/Product';
import Title from '../component/Title';
import Title2 from '../component/Title2';
import nike from '../data/nike';
import axios from 'axios';

function Home(props){
    // let[res, setRes]=useState([0,1,2,3,4,5,6,7,8]);
    let [nike1, setNike1] = useState(nike);
    let [count,setCount]=useState(1);
    return (
      <>
        <div className='slider'></div>

        <Title/>
        <Button variant="outline-primary" onClick={()=>{
          let copy=[...props.shoes].sort((a,b)=>a.title>b.title ? 1:-1)
          props.setShoes(copy);
        
          let res1=[];
          for(let i in copy){
            res1.push(copy[i].id);
          }

          props.setRes(res1);
        }}>이름순 정렬</Button>{' '}
        <Button variant="outline-secondary"  onClick={()=>{
          let copy=[...props.shoes].sort((a,b)=>a.price>b.price ? 1:-1)
          props.setShoes(copy);

          let res1=[];
          for(let i in copy){
            res1.push(copy[i].id)
          }

          props.setRes(res1);
        }}>낮은가격순 정렬</Button>{' '}
        <Button variant="outline-success"  onClick={()=>{
          let copy=[...props.shoes].sort((a,b)=>a.price<b.price ? 1:-1)
          props.setShoes(copy);

          let res1=[];
          for(let i in copy){
            res1.push(copy[i].id)
          }

          props.setRes(res1);
        }}>높은가격순 정렬</Button>{' '} 

        <Container>
          <Row>
            {
              props.shoes.map((a, i) => {
                return (
                  <Product shoes={props.shoes[i]} i={i} res={props.res} setres={props.setRes}/>
                )
              })
            }
          </Row>
        </Container>
            <Title2/>
            <Button variant="outline-success" count={count} onClick={()=>{
              if(count===1){
                axios.get('https://zhzhahd.github.io/json/nike2.json').then((result)=>{
                  let copy=[...nike1,...result.data];
                  setNike1(copy);
                  setCount(2);
                })
              }else if(count===2){
                axios.get('https://zhzhahd.github.io/json/nike3.json').then((result)=>{
                  let copy=[...nike1,...result.data];
                  setNike1(copy);
                  setCount(3);
                })
              }else{
                alert('더이상 상품이 없습니다.');
              }
            }}> + 3개 상품 더 보기 </Button>{' '}
            <Container style={{marginTop:'30px'}}>
              <Row>
                {
                  nike1.map((ele, i) => {
                    return (
                      <Nike nike1={nike1[i]} />
                    )
                  })
                }
              </Row>
            </Container>
 
      </>
    )
  }
  function Nike(props) {
    return (  
      <Col md={4}>        
        <img alt="item2" src={props.nike1.imgUrl} width="80%" />  
        <h5>{props.nike1.title}</h5>
        <p>{props.nike1.content}</p>
        <p>{props.nike1.price}</p>      
      </Col>
    )
  }

  export default Home;
